import styled, { css } from 'styled-components';

export const NoticeText = styled.span`
  font-size: 12px;
  line-height: 16px;
  color: #abadae;
`;

export const Title = styled.div`
  color: #000000;
  font-size: 13px;
  font-weight: 700;
`;

export const StageBlock = styled.div`
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
`;

export const TypeWrap = styled.div`
  margin-top: 10px;
  width: 100%;
  position: 'relative';
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const TypeBlock = styled.div`
  width: 30%;
  height: 100px;
  background-color: rgb(244, 248, 249);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 10px;
  cursor: pointer;
  margin-bottom: 10px;

  &:hover {
    background-color: #E6EEF0;
  }
`;

export const TypeIcon = styled.div`
  flex: 3;
  width: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  margin-bottom: 10px;

  ${(props: {icon: string}) => css`
    background-image: url("${props.icon}");
  `}
`;

export const TypeName = styled.div`
  height: 16px;
  text-align: center;
  font-size: 12px;
  width: 100%;
  font-weight: 400;
  color: #6a8b9c;
  text-transform: uppercase;

  white-space: nowrap;
`;

export const TitleInput = styled.input`
  margin-top: 5px;
  margin-bottom: 15px;
  width: 100%;
  border-width: 0;
  border-bottom: 2px solid #efefef;
  color: #000;
  font-size: 16px;

  &:hover {
    border-color: #009788;
  }
`;

export const DetailsTextArea = styled.textarea`
  margin-top: 5px;
  margin-bottom: 15px;
  width: 100%;
  border-width: 0;
  border-bottom: 2px solid #efefef;
  color: #000;
  font-size: 16px;

  &:hover {
    border-color: #009788;
  }
`;

export const SubmitButtonWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
